import React, { FC } from 'react'
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  root: {
    
  },
}))

const NotFound: FC<React.PropsWithChildren<unknown>> = ({

}) => {
  const classes = useStyles()

  return (
    <div className={ classes.root }>
      Not found
    </div>
  )
}

export default NotFound